import { END_LOADING_PROFILE, END_LOADING_USER_POSTS, FETCH_MORE_USER_POSTS, FETCH_PROFILE, FETCH_SUGGESTED_USERS, FETCH_USER_POSTS, FOLLOW_USER, SEARCH_USERS, START_LOADING_PROFILE, START_LOADING_USER_POSTS, UNFOLLOW_USER } from "../constants/actionTypes";

const profileReducer = (state={user: {}, posts: []}, action) => {

    let newState = {};

    switch(action.type){

        //loading state cases
        case START_LOADING_PROFILE:
            return {
                ...state,
                profileLoading: true
            }

        case END_LOADING_PROFILE:
            return {
                ...state,
                profileLoading: false
            }

        case START_LOADING_USER_POSTS:
            return {
                ...state,
                userPostsLoading: true
            }

        case END_LOADING_USER_POSTS:
            return {
                ...state,
                userPostsLoading: false
            }

        case SEARCH_USERS:

            return {
                ...state,
                searchResults: action.payload.data
            }

        case FETCH_PROFILE:

            return {
                ...state,
                user: action.payload.data
            }


        case FETCH_USER_POSTS:

            return {
                ...state,
                posts: action.payload.data,
                currentPage: 1,
                numberOfPages: action.payload.numberOfPages
            }

        case FOLLOW_USER:

            return {
                ...state,
                user: {
                    ...state.user,
                    ...action.payload.followedUser
                }
            }

        case UNFOLLOW_USER:

            return {
                ...state,
                user: {
                    ...state.user,
                    ...action.payload.followedUser
                }
            }

        case FETCH_MORE_USER_POSTS:

            return {
                ...state,
                posts: [...state.posts, ...action.payload.data],
                currentPage: action.payload.currentPage,
                numberOfPages: action.payload.numberOfPages
            }

        case FETCH_SUGGESTED_USERS:

            console.log('fetch suggested users payload: ', action.payload);

            return {
                ...state,
                suggestedUsers: [
                    ...action.payload.users
                ]
            }

        default:
            return state;
    }
}

export default profileReducer;